import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { 
  LayoutDashboard, 
  Users, 
  ClipboardCheck, 
  CreditCard, 
  BarChart3, 
  Settings,
  Building2,
  LogOut,
  Key
} from 'lucide-react';

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const { logout, company } = useAuth();
  
  const getCompanySlug = () => {
    if (company?.slug && company.slug.toLowerCase() !== 'demo') {
      return company.slug;
    }
    const pathParts = window.location.pathname.split('/');
    const companyIndex = pathParts.findIndex(part => part === 'client') + 1;
    const fromPath = pathParts[companyIndex];
    if (fromPath && fromPath.toLowerCase() !== 'demo') {
      return fromPath;
    }
    return null;
  };

  const companySlug = getCompanySlug();
  
  const navigation = companySlug ? [
    { name: 'Dashboard', href: `/client/${companySlug}/admin/dashboard`, icon: LayoutDashboard },
    { name: 'Employees', href: `/client/${companySlug}/admin/employees`, icon: Users },
    { name: 'Signup Codes', href: `/client/${companySlug}/admin/signup-codes`, icon: Key },
    { name: 'Approvals and Loan', href: `/client/${companySlug}/admin/approvals`, icon: ClipboardCheck },
    { name: 'Transactions', href: `/client/${companySlug}/admin/transactions`, icon: CreditCard },
    { name: 'Reports', href: `/client/${companySlug}/admin/reports`, icon: BarChart3 },
    { name: 'Settings', href: `/client/${companySlug}/admin/settings`, icon: Settings },
  ] : [];

  const handleSignOut = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="hidden md:flex md:flex-shrink-0">
      <div className="flex flex-col w-64">
        <div className="flex flex-col h-0 flex-1 bg-white border-r border-gray-200">
          {/* Logo */}
          <div className="flex items-center h-16 px-6 bg-gradient-to-r from-primary-800 to-primary-600">
            <Building2 className="h-8 w-8 text-white" />
            <div className="ml-3">
              <h1 className="text-lg font-bold text-white leading-tight">VPD Employer Portal</h1>
              <p className="text-xs text-primary-100">Admin</p>
            </div>
          </div>
          
          {/* Navigation */}
          <div className="flex-1 flex flex-col overflow-y-auto">
            <nav className="flex-1 px-4 py-6 space-y-2">
              {navigation.map((item) => {
                const Icon = item.icon;
                return (
                  <NavLink
                    key={item.name}
                    to={item.href}
                    className={({ isActive }) =>
                      `group flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 ${
                        isActive
                          ? 'bg-primary-100 text-primary-700 border-r-2 border-primary-600'
                          : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                      }`
                    }
                  >
                    <Icon className="mr-3 h-5 w-5" />
                    {item.name}
                  </NavLink>
                );
              })}
            </nav>
            
            {/* Sign Out Button */}
            <div className="px-4 py-6 border-t border-gray-200">
              <button
                onClick={handleSignOut}
                className="w-full group flex items-center px-3 py-2 text-sm font-medium text-red-600 hover:bg-red-50 hover:text-red-700 rounded-lg transition-colors duration-200"
              >
                <LogOut className="mr-3 h-5 w-5" />
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
